import styled from 'styled-components';

export const Container = styled.div`
    font-size: 0.9rem;
    border-left: 1px solid #CCC;
    position: relative;
    padding-left: 0.7rem;

    .openButtonRegion{
        color: #535354;
        margin-left: 0.5rem;
        transform: ${props => props.openRegion ? 'rotate(180deg)' : 'none'};
        transition: transform .25s;
    }

    .cleanRegionButton{
        opacity: 0;
        transition: opacity 0.15s;
    }

    .text{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.5rem;
        color: #535354;

        &:hover {
            .cleanRegionButton{
                opacity: 1;
            }
        }
    }

    .regionBullet{
        height: 0.7rem;
        width: 0.7rem;
        border-radius: 50%;
        background: #000;
        position: absolute;
        top: 0;
        left: 0;
        transform: translate(-50%, 100%);
        background: #7A05A7;
    }
`
